
import api from './base'

export default {
  statusDelovnegaCasa ({ businessUnitId, status, headers }) {
    if (status === 0) {
      return api().delete(`company/business_units/${businessUnitId}/work_time`, { headers: headers })
    } else {
      return api().put(`company/business_units/${businessUnitId}/work_time`, {}, { headers: headers })
    }
  },

  // @Deprecated
  currentSessionWorkTime ({ businessUnitId, dateFrom, dateTo, user }) {
    // https://api.hitriracun.si/web_api/company/business_units/1696329286/work_time?dateFrom=2021-05-01&dateTo=2022-05-14&api_key=216c80d1-e584-4769-a8dc-ea8ed50013c1
    let url = `company/business_units/${businessUnitId}/work_time`
    if (dateFrom) {
      url += `?dateFrom=${dateFrom}`
    }
    if (dateTo) {
      url += `&dateTo=${dateTo}`
    }
    if (user) {
      url += `&user=${user}`
    }
    return api().get(url)
  },

  generirajPrikazDC ({ businessUnitId, dateFrom, dateTo, user }) {
    let url = `company/business_units/${businessUnitId}/work_time_summary`
    if (dateFrom) {
      url += `?dateFrom=${dateFrom}`
    }
    if (dateTo) {
      url += `&dateTo=${dateTo}`
    }
    if (user) {
      url += `&user=${user}`
    }
    return api().get(url)
  },

  addUserWorkTime ({ businessUnitId, data }) {
    return api().put(`company/business_units/${businessUnitId}/user_work_time`, data)
  },

  /* editUserWorkTime({ businessUnitId, data }) {
    return api().put(``)
  }, */

  removeUserWorkTime ({ businessUnitId, workTimeId }) {
    return api().delete(`company/business_units/${businessUnitId}/user_work_time/${workTimeId}`)
  }

}
